module.exports = __webpack_public_path__ + "img/banner_songjiang.35bd5432.png";